import { useStore } from "../../../stores/StoreContext";

export const useIsImageGenDisabled = (): boolean => {
  const { budgetStore } = useStore();

  return budgetStore.hasBudget === false;
};
